import { render, staticRenderFns } from "./social-source.vue?vue&type=template&id=053e82bd&"
import script from "./social-source.vue?vue&type=script&lang=js&"
export * from "./social-source.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports